import K from '../constants';
import restHelpers from '../helpers/restHelper';
import getMockresponse from './__mocks/rpm/get';

const getAllFn = (carId, startDate, endDate) => restHelpers.withBearer.get(`${K.API_URL}/rpms/cars/${carId}/${startDate}/${endDate}`, {});
const getMockFnIgnored = () => Promise.resolve(getMockresponse);

export default {
  _getAll: getMockFnIgnored,
  getAll: getAllFn
};



// WEBPACK FOOTER //
// ./src/services/rpms.js